import { create } from 'zustand';

const initialState = {
    moduleName: null,
    gridData: [],
    searchControls: [],
    isListChanged: true,
    filterControlValues: {},
    hoverFilterValues: null,
    filterPayload: null,
};


export const useApproverStore = create((set, get) => ({
    // State
    ...initialState,

    // Setters
    setModuleName: (name) => set({ moduleName: name }),
    setGridData: (data) => set({ gridData: data }),
    setSearchControls: (data) => set({ searchControls: data }),
    setIsListChanged: (data) => set({ isListChanged: data }),
    setFilterControlValues: (data) => set({ filterControlValues: data }),
    setHoverFilterValues: (data) => set({ hoverFilterValues: data }),
    setFilterPayload: (data) => set({ filterPayload: data }),

    // Reset store
    destroy: () => set({ ...initialState }),
    // Initialize with optional values
    initialize: (values = {}) => set({ ...initialState, ...values }),
}));